import { HasCartLineContext, withCartLine } from "@insite/client-framework/Components/CartLineContext";
import { HasProductContext, withProductContext } from "@insite/client-framework/Components/ProductContext";
import ProductBrand from "@insite/content-library/Components/ProductBrand";
import GridContainer, { GridContainerProps } from "@insite/mobius/GridContainer";
import GridItem, { GridItemProps } from "@insite/mobius/GridItem";
import ProductDescription from "@store/Overrides/Components/ProductDescription";
import ProductImage from "@store/Overrides/Components/ProductImage";
import React, { FC } from "react";
import { css } from "styled-components";

interface OwnProps {}

type Props = OwnProps & HasProductContext & HasCartLineContext;

export interface ProductPreviewStyles {
    productContainer?: GridContainerProps;
    productImageItem: GridItemProps;
    productDescriptionItem: GridItemProps;
}

export const productPreviewStyles: ProductPreviewStyles = {
    productContainer: {
        css: css`
            align-items: center;
        `
    },
    productImageItem: {
        width: 4,
        css: css`
            padding-right: 0;
        `,
    },
    productDescriptionItem: {
        width: 8,
        css: css`
            display: flex;
            flex-direction: column;
            justify-content: center;
        `,
    },
};

const styles = productPreviewStyles;

const ProductPreview: FC<Props> = ({ cartLine, productContext }) => {
    const product =  productContext.product ? productContext : cartLine;
    const productInfo = productContext.product ? productContext.product : cartLine;

    return (
        <GridContainer {...styles.productContainer}>
            <GridItem {...styles.productImageItem}>
                <ProductImage
                    product={product}
                    imagePath={productInfo?.smallImagePath}
                />
            </GridItem>
            <GridItem {...styles.productDescriptionItem}>
                {productInfo.brand && (
                    <ProductBrand brand={productInfo.brand} />
                )}
                <ProductDescription product={product} />
            </GridItem>
        </GridContainer>
    );
};

export default withCartLine(withProductContext(ProductPreview));
